import React, { PureComponent } from 'react'

import InView from '../InView/InView'
import cx from '../../../utils/className'

import styles from './SingleColumn.module.css'
class SingleColumn extends PureComponent {
  handleReachEnd = inView => {
    if (inView) {
      if (typeof this.props.onReachEnd === 'function') {
        this.props.onReachEnd()
      }
    }
  }

  /* --------------------------------------- */

  renderElements() {
    const { childIs, childItems, childOptions } = this.props

    const ChildComponent = childIs

    const isNeedTriggerReachEnd = i => i === childItems.length - 1
    if (childItems) {

      const elements = childItems.map((item, i) => {
        const element = (
          <ChildComponent
            key={i}
            {...item}
            {...childOptions}
            itemIndex={i}
          ></ChildComponent>
        )

        if (isNeedTriggerReachEnd(i)) {
          return (
            <InView key={i} onChange={this.handleReachEnd} triggerOnce={true}>
              {element}
            </InView>
          )
        }

        return element
      })

      return elements
    } else {
      return  []
    }
  }

  componentDidMount() {
    const noChild = !this.props.childItems || !this.props.childItems.length
    if (noChild && this.props.skipEmptyReachEnd !== true
      && typeof this.props.onReachEnd === 'function') {
      this.props.onReachEnd()
    }
  }

  render() {
    const elements = this.renderElements()

    return (
      <div className={cx(styles.list, this.props.className)}>{elements}</div>
    )
  }
}

export default SingleColumn
